import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import HumanAgentEntity from "../../../../domain/entities/human_agent.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import HumanAgentDto from "../../../dto/human_agent.dto";

const getHumanAgentByIdApiImpl = async (id: string): Promise<Either<ErrorEntity, HumanAgentEntity>> => {
    try {
        const relativeUrl: string = `/human-agent/${id}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = HumanAgentDto.fromJSON(response);
        return right(parsed)
    } catch (e) {
        return left({ code: "Error" });
    }
};

export default getHumanAgentByIdApiImpl;